import { render, staticRenderFns } from "./supply.vue?vue&type=template&id=4cd62570"
import script from "./supply.vue?vue&type=script&lang=js"
export * from "./supply.vue?vue&type=script&lang=js"
import style0 from "./supply.vue?vue&type=style&index=0&id=4cd62570&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_gliqtm7r2yknapxh4mg6r2qyi4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports